import { component } from 'picoapp'

class CartRedirect {
  constructor(node, ctx) {
    this._ctx = ctx;

    // redirect to home and open cart...
    this._ctx.getState().router.loadUrl('/')

    // open cart
    setTimeout(() => {
      this._ctx.emit('cart:toggle', (state) => {
        return {
          cartOpen: true
        }
      })
    }, 1000);

    // unmount
    return this.unmount.bind(this);
  }

  /**
   * Handle unmount.
   */
  unmount() {
  }
}

export default component((node, ctx) => new CartRedirect(node, ctx))
